import {Pipe, PipeTransform} from '@angular/core';
import {AsYouType, format, parse} from 'libphonenumber-js';

@Pipe({
    name: 'email',
    standalone: true
})
export class EmailPipe implements PipeTransform {

  static isValidEmail(email): boolean {
    const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }

  transform(value: string, showValidation?: boolean): string {
    if (!value) {
      return value;
    }

    if (!EmailPipe.isValidEmail(value) && showValidation) {
      return `${value} (invalid)`;
    }

    return value;
  }
}
